import React from 'react';
import css from './EmailPreview.module.scss';

const EmailPreview: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={css['email-preview']}>{children}</div>
);

export default EmailPreview;
